(() => {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const hero = root.querySelector('[data-hero-video]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (hero?.querySelector('source') && !reducedMotion.matches) {
      hero.muted = true;
      hero.play().catch(() => {});
    }
    reducedMotion.addEventListener('change', (event) => {
      if (event.matches) hero?.pause();
    });

    const marquee = root.querySelector('[data-trust-track]');
    const marqueeGroup = marquee?.firstElementChild;
    if (marqueeGroup) {
      const measure = () => {
        const width = marqueeGroup.getBoundingClientRect().width;
        if (width > 0) {
          marquee.style.setProperty('--loop-distance', `-${width}px`);
          marquee.style.setProperty('--loop-duration', `${Math.round(width / 40)}s`);
        }
      };
      new ResizeObserver(measure).observe(marqueeGroup);
      (document.fonts?.ready || Promise.resolve()).then(() =>
        requestAnimationFrame(() => {
          measure();
          requestAnimationFrame(() => marquee.classList.add('is-loop-ready'));
        }),
      );
    }

    const stories = root.querySelectorAll('.lv-story');
    const pauseOtherStories = (activeCard) => {
      stories.forEach((card) => {
        if (card !== activeCard) card.querySelector('video').pause();
      });
    };
    stories.forEach((card, index) => {
      const video = card.querySelector('video');
      const button = card.querySelector('[data-story-play]');
      const sync = () => {
        const playing = !video.paused;
        card.classList.toggle('is-playing', playing);
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} video ${index + 1}`);
        button.firstElementChild.textContent = playing ? 'Ⅱ' : '▶';
      };
      button.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          return;
        }
        pauseOtherStories(card);
        video.controls = true;
        video.play().catch(sync);
      });
      video.addEventListener('play', () => {
        pauseOtherStories(card);
        sync();
      });
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
    });

    const track = root.querySelector('[data-story-track]');
    if (!track) return;

    const previous = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    const syncNavigation = () => {
      if (!previous || !next) return;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    function move(direction) {
      if (!track.firstElementChild) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 18;
      track.scrollBy({
        left: direction * (track.firstElementChild.getBoundingClientRect().width + gap),
        behavior: reducedMotion.matches ? 'instant' : 'smooth',
      });
    }
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', syncNavigation, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    new ResizeObserver(syncNavigation).observe(track);
    syncNavigation();
  }
  document.querySelectorAll('.lv-home').forEach(init);
  document.addEventListener('shopify:section:load', (event) =>
    event.target.querySelectorAll('.lv-home').forEach(init),
  );
})();
